import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { arrangementType } from 'types/bereavement';
import {
  filterSelectionsOnArrangement,
  filterSelectionsOptions,
  getArrangementSelectionsSortedByEstimateOrder,
  getPlaceholderSelectionsForArrangement,
} from 'services/utils/arrangement';
import SortableEstimateSelectionsList from 'components/estimate/SortableEstimateSelectionsList';

class EstimateMainSelectionsContainer extends Component {
  static propTypes = {
    bereavementId: PropTypes.string.isRequired,
    arrangement: arrangementType.isRequired,
    onOpenConfirmationWarningModal: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    onSortEnd: PropTypes.func.isRequired,
  };

  getSelections() {
    const { arrangement } = this.props;
    const mainFilters = [
      filterSelectionsOptions.ALL,
      filterSelectionsOptions.NON_DISPLAY_AS_DISBURSEMENTS,
      filterSelectionsOptions.NON_PROFESSIONAL_SERVICES,
    ];
    const selections = getArrangementSelectionsSortedByEstimateOrder(
      arrangement,
      filterSelectionsOnArrangement(arrangement, mainFilters),
    );
    return [
      ...selections,
      ...getPlaceholderSelectionsForArrangement(arrangement, filterSelectionsOptions.ALL),
    ];
  }

  handleSelectionReorder = ({ oldIndex, newIndex }) => {
    const { onSortEnd } = this.props;
    const selections = this.getSelections();
    onSortEnd(selections[oldIndex], selections[newIndex]);
  }

  render() {
    const {
      bereavementId,
      arrangement,
      disabled,
      onOpenConfirmationWarningModal,
    } = this.props;

    return (
      <SortableEstimateSelectionsList
        bereavementId={bereavementId}
        arrangement={arrangement}
        disabled={disabled}
        onOpenConfirmationWarningModal={onOpenConfirmationWarningModal}
        selections={this.getSelections()}
        onSortEnd={this.handleSelectionReorder}
        distance={1}
      />
    );
  }
}

export default EstimateMainSelectionsContainer;
